import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {AppFormsModule} from '../forms/forms.module';
import {SharedModule} from './shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import {
  MatAutocompleteModule,
  MatButtonToggleModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatSelectModule,
  MatSliderModule,
  MatTabsModule,
  MatTooltipModule
} from '@angular/material';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgxEditorModule} from 'ngx-editor';
import {NgxMaskModule} from 'ngx-mask';
import {EnrollCabinetComponent} from '../enroll/components/enroll-cabinet/enroll-cabinet.component';
import {EnrollPersonalInfoComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-personal-info/enroll-personal-info.component';
import {EnrollDocumentsComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-documents/enroll-documents.component';
import {EnrollContactsComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-contacts/enroll-contacts.component';
import {EnrollEduInfoComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-edu-info/enroll-edu-info.component';
import {EnrollEntransInfoComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-entrans-info/enroll-entrans-info.component';
import {EnrollContractPaymentInfoComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-contract-payment-info/enroll-contract-payment-info.component';
import {EnrollPersonalAchievementsComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-personal-achievements/enroll-personal-achievements.component';
import {EnrollPrivilegesComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-privileges/enroll-privileges.component';
import {EnrollMilitaryRegistrationInfoComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-military-registration-info/enroll-military-registration-info.component';
import {AddParentsDialogComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-personal-info/add-parents-dialog/add-parents-dialog.component';
import {AchievementFilesComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-personal-achievements/achievement-files/achievement-files.component';
import {AddPrivilegeDialogComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-privileges/add-privilege-dialog/add-privilege-dialog.component';
import {AchievementFileAddComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-personal-achievements/achievement-files/achievement-file-add/achievement-file-add.component';
import {CenterNationalityService} from '../user/services/center-nationality.service';
import {DictionaryService} from './services/dictionary.service';
import {CenterCollegeService} from '../../common_services/center-college.service';
import {EnrollApplicationService} from '../common-main/services/enroll-application.service';
import {RouterModule} from '@angular/router';
import {EnrolleListService} from '../user/services/enrolle-list.service';
import {CommonDialogComponent} from '../enroll/components/enroll-cabinet/dialogs/common-dialog/common-dialog.component';
import {AttestatBallCalaulateDialogComponent} from 'app/modules/enroll/components/enroll-cabinet/tabs/enroll-edu-info/attestat-ball-calaulate-dialog/attestat-ball-calaulate-dialog.component';
import {QualificationsService} from '../enroll/services/qualifications.service';
import {EnrollCabinetValidation} from '../enroll/components/enroll-cabinet/enroll-cabinet-validation';
import {AlternativeCollegesService} from '../enroll/services/alternative-colleges.service';
import {EnrollEgovFilesComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-egov-files/enroll-egov-files.component';
import {EnrollCommissionDecisionComponent} from '../enroll/components/enroll-cabinet/tabs/enroll-commission-decision/enroll-commission-decision.component';

@NgModule({
    imports: [
        AppFormsModule,
        SharedModule,
        ReactiveFormsModule,
        NgSelectModule,
        MatDialogModule,
        MatTabsModule,
        MatButtonToggleModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatSelectModule,
        MatSliderModule,
        NgxEditorModule,
        MatExpansionModule,
        RouterModule,
    NgxMaskModule.forRoot()
    ],
  declarations: [
    EnrollCabinetComponent,
    EnrollPersonalInfoComponent,
    EnrollDocumentsComponent,
    EnrollContactsComponent,
    EnrollEduInfoComponent,
    EnrollEntransInfoComponent,
    EnrollContractPaymentInfoComponent,
    EnrollPersonalAchievementsComponent,
    EnrollPrivilegesComponent,
    EnrollCommissionDecisionComponent,
    EnrollMilitaryRegistrationInfoComponent,
    AddParentsDialogComponent,
    AchievementFilesComponent,
    AddPrivilegeDialogComponent,
    AchievementFileAddComponent,
    CommonDialogComponent,
    AttestatBallCalaulateDialogComponent,
    EnrollEgovFilesComponent
  ],
  providers: [
    EnrollApplicationService,
    CenterNationalityService,
    DictionaryService,
    CenterCollegeService,
    EnrollEduInfoComponent,
    EnrolleListService,
    QualificationsService,
    AlternativeCollegesService,
    EnrollCabinetValidation
  ],
  exports: [
  ],
  entryComponents: [
    AddParentsDialogComponent,
    AddPrivilegeDialogComponent,
    CommonDialogComponent,
    AttestatBallCalaulateDialogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EnrollUserSharedModule { }



// WEBPACK FOOTER //
// ./src/app/modules/shared/enroll-user-shared.module.ts